// useFetchTvChannels.js
import axios from "axios";
import useGetImages from "./useGetImages";
import useGetChannelCategories from "./useGetChannelCategories";
import useGlobalStore from "../stores/globalStore";

const useGetTvChannels = () => {
  // Store
  const setFlexCategories = useGlobalStore((state) => state.setFlexCategories);

  // Hooks
  const { getImages } = useGetImages();
  const { getChannelCategories } = useGetChannelCategories();

  const getTvChannels = async () => {
    try {
      let allData: any[] = [];

      try {
        // First request
        const response1 = await axios.get(
          `${window.location.origin}/wp-json/wp/v2/produkter/tv_kanaler?_fields=title,acf,id,type,slug,kanal_kategorier,featured_media&order=asc&per_page=75&page=1`
        );

        // Handle response1 data as needed
        allData = [...allData, ...response1.data];

        // Second request based on the first response
        const response2 = await axios.get(
          `${window.location.origin}/wp-json/wp/v2/produkter/tv_kanaler?_fields=title,acf,id,type,slug,kanal_kategorier,featured_media&order=asc&per_page=75&page=2`
        );
        allData = [...allData, ...response2.data]; 

        // Handle response2 data as needed
      } catch (error) {
        // Handle errors for either request
        console.error("Error:", error);
      }

      // Fetching images
      const imageArray = await getImages(allData);

      // Fetch all channel categories
      const channelCategories = await getChannelCategories();

      // Storing channel categories into state
      setFlexCategories(channelCategories?.filter((channelCat) => channelCat.parentId > 0));

      // Replace ids in kanal_kategorier with corresponding names
      const updatedData = allData.map((tvChannel) => ({
        ...tvChannel,
        kanal_kategorier: tvChannel.kanal_kategorier.map((categoryId) => {
          const category = channelCategories?.find((cat) => cat.id === categoryId);
          return category ? category.title : categoryId;
        }),

        isFlex: tvChannel.kanal_kategorier.some((categoryId) => {
          const flexCategory = channelCategories?.find((cat) => cat.title.includes("Flex"));

          const flexCategories = channelCategories
            ?.map((cat) => {
              if (cat.id === flexCategory.id || cat.parentId === flexCategory.id) {
                return cat.id;
              }
              return null;
            })
            .filter((categoryId) => categoryId !== null);

          return flexCategories?.some((catId) => catId === categoryId);
        }),
      }));

      // Remapping object
      const tvChannels = updatedData.map((tvChannel, index) => ({
        id: tvChannel.id,
        slug: tvChannel.slug,
        type: tvChannel.type,
        title: tvChannel.title.rendered,
        image: imageArray[index],
        kanal_kategorier: tvChannel.kanal_kategorier,
        isFlex: tvChannel.isFlex,
      }));

      return tvChannels;
    } catch (error) {
      console.error("Error fetching TV channels:", error);
      throw error;
    }
  };

  return { getTvChannels };
};

export default useGetTvChannels;
